import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import Hero from "../../components/home/Hero";
import Benefits from "../../components/home/Benefits";
import HomeProductSection from "../../components/home/HomeProductsSection";
import { getAllProducts } from "../../redux/reducers/productSlice";

const Home = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    // Fetch products from backend when component mounts
    dispatch(getAllProducts());
  }, [dispatch]);

  return (
    <>
      <Hero />
      <Benefits />
      <HomeProductSection />
    </>
  );
};

export default Home;
